export const GET_DETAILS = 'GET_DETAILS'
export const GET_DETAILS_LOADING = 'GET_DETAILS_LOADING'
export const UPDATE_POST = 'UPDATE_POST'
export const SET_PRERENDERED_DETAILS = 'SET_PRERENDERED_DETAILS'
